
<template>
  <div>
    <b-card no-body  id="listEvaluaciones"  >
      <b-card-body>
        <div class="d-flex justify-content-between  flex-wrap">
          <!-- Registar Empresa  -->
          <b-form-group
              label-for="filterInput"
              class="mb-0"
          >
            <b-button
                variant="gradient-secondary"
                size="sm"
                class="mr-1"
                @click="traerForecasting"
            >
              <feather-icon
                  icon="RefreshCwIcon"
              />
            </b-button>
            <b-button
                variant="gradient-primary"
                size="sm"
                @click="mostrarModal(1, 0, '','')"
            >
              <feather-icon
                  icon="PlusIcon"
                  class="mr-50"
              />
              <span class="align-middle">Registrar Forecast</span>

            </b-button>

          </b-form-group>

          <!-- filter -->
          <b-form-group
              label-for="filterInput"
              class="mb-0"
          >
            <b-input-group size="sm">
              <b-form-input
                  id="filterInput"
                  v-model="filter"
                  type="search"
                  placeholder="Buscar"
              />
              <b-input-group-append>
                <b-button
                    :disabled="!filter"
                    @click="filter = ''"
                >
                  Borrar
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>

        </div>
      </b-card-body>

      <b-table
          hover
          responsive
          class="position-relative"
          :per-page="perPage"
          :current-page="currentPage"
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="cPaginacion"
          :busy="loading"
          show-empty
          empty-text="No se encontraron datos en esta tabla."
          id="table-evaluaciones"
      >
        <template #table-busy>
          <div class="text-center text-dark my-1">
            <b-spinner class="align-middle"></b-spinner> &emsp;
            <strong>Obteniendo datos...</strong>
          </div>
        </template>

        <template #cell(fecha)="data">
        <span class="text-nowrap">
          {{
            new Date(data.value).toLocaleString('pe-PE', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              localeMatcher: 'best fit',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              timeZone: 'America/Lima'
            })
          }}
        </span>
        </template>
        <template #cell(estado)="data">
          <b-badge :variant="status[1][data.value]">
            {{ status[0][data.value] }}
          </b-badge>
        </template>
        <template #cell(acciones)="data">
          <div class="text-nowrap">
            <feather-icon v-if="data.item.estado=='1'"
                          :id="`btn_${data.item.id}_editar`"
                          icon="MinusCircleIcon"
                          style="color: #E74C3C"
                          size="16"
                          class="mx-1"
                          @click="anularRegistro(data.item.id,data.item.estado)"
            />
            <feather-icon v-if="data.item.estado=='0'"
                          :id="`btn_${data.item.id}_editar`"
                          icon="CheckCircleIcon"
                          style="color: #28B463"
                          size="16"
                          class="mx-1"
                          @click="anularRegistro( data.item.id, data.item.estado)"
            />


            <b-tooltip v-if="data.item.estado=='1'"
                       title="Anular registro"
                       style="background-color:#E74C3C"
                       :target="`btn_${data.item.id}_editar`"
            />
            <b-tooltip v-if="data.item.estado=='0'"
                       title="Activar registro"
                       style="background-color:#28B463"
                       :target="`btn_${data.item.id}_editar`"
            />

            <feather-icon v-if="data.item.estado=='1'"
                          :id="`btn_${data.item.id}_agregar`"
                          icon="PlusCircleIcon"
                          style="color: #28B463"
                          size="16"
                          class="mx-1"
                          @click="verCagetorias(data.item.id,data.item.nombre_cultivo)"
            />
            <feather-icon v-if="data.item.estado=='0'"
                          :id="`btn_${data.item.id}_agregar`"
                          icon="PlusCircleIcon"
                          style="color: #E74C3C"
                          size="16"
                          class="mx-1"
                          disabled=""
            />


            <b-tooltip v-if="data.item.estado=='1'"
                       title="Agregar Detalle"
                       style="background-color:#E74C3C"
                       :target="`btn_${data.item.id}_agregar`"
            />


          </div>
        </template>

      </b-table>

      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <!-- page length -->
        <b-form-group
            label="Mostrar"
            label-cols="5"
            label-align="left"
            label-size="sm"
            label-for="sortBySelect"
            class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
              id="perPageSelect2"
              v-model="perPage"
              size="sm"
              inline
              :options="pageOptions"
          />

        </b-form-group>

        <!-- pagination -->
        <div>
          <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              class="mb-0"
          >
            <template #prev-text>
              <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-card-body>

    </b-card>
    <b-card no-body  style="display: none" id="listCategorias"  >
      <b-card-body>
        <div class="d-flex justify-content-between  flex-wrap">
          <!-- Registar Empresa  -->

          <b-form-group
              label-for="filterInput"
              class="mb-0"
          >
            <b-button
                variant="gradient-danger"
                size="sm"
                class="mr-1"
                @click="regresarInicio"
            >
              <feather-icon
                  icon="ArrowLeftIcon"
              />
              Regresar
            </b-button>

            <b-button
                variant="gradient-success"
                size="sm"
                class="mr-1"
                @click="mostrarModalDetalle(1, 0, '','')"
            >
              <feather-icon
                  icon="PlusIcon"
              />
              Registrar Detalle
            </b-button>

            <b>Lista de detalle</b>
          </b-form-group>
          <!-- filter -->
          <b-form-group
              label-for="ilter_categoriaInput"
              class="mb-0"
          >
            <b-input-group size="sm">
              <b-form-input
                  id="filter_categoriaInput"
                  v-model="filter_categoria"
                  type="search"
                  placeholder="Buscar"
              />
              <b-input-group-append>
                <b-button
                    :disabled="!filter_categoria"
                    @click="filter_categoria = ''"
                >
                  Borrar
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>

        </div>
      </b-card-body>

      <b-table
          hover
          responsive
          class="position-relative"

          :per-page="perPage_c"
          :current-page="currentPage_c"
          :items="itemsCategorias"
          :fields="fieldsCategorias"
          :sort-by.sync="sortBy_c"
          :sort-desc.sync="sortDesc_c"
          :sort-direction="sortDirection_c"
          :filter="filter_categoria"
          :filter-included-fields="filterOnCategoria"
          @filtered="cPaginacion_c"
          :busy="loading_c"
          show-empty
          empty-text="No se encontraron datos en esta tabla."
          id="table-categorias"
      >
        <template #table-busy>
          <div class="text-center text-dark my-1">
            <b-spinner class="align-middle"></b-spinner> &emsp;
            <strong>Obteniendo datos...</strong>
          </div>
        </template>

        <template #cell(detalle_estado)="data">
          <b-badge :variant="status[1][data.value]">
            {{ status[0][data.value] }}
          </b-badge>
        </template>

        <template #cell(acciones_detalle)="data">
          <div class="text-nowrap">
            <feather-icon v-if="data.item.detalle_estado=='1'"
                          :id="`btn_${data.item.id}_editar`"
                          icon="MinusCircleIcon"
                          style="color: #E74C3C"
                          size="16"
                          class="mx-1"
                          @click="anularRegistroDetalle(data.item.id,data.item.detalle_estado)"
            />
            <feather-icon v-if="data.item.detalle_estado=='0'"
                          :id="`btn_${data.item.id}_editar`"
                          icon="CheckCircleIcon"
                          style="color: #28B463"
                          size="16"
                          class="mx-1"
                          @click="anularRegistroDetalle( data.item.id, data.item.detalle_estado)"
            />


            <b-tooltip v-if="data.item.detalle_estado=='1'"
                       title="Anular registro"
                       style="background-color:#E74C3C"
                       :target="`btn_${data.item.id}_editar`"
            />
            <b-tooltip v-if="data.item.detalle_estado=='0'"
                       title="Activar registro"
                       style="background-color:#28B463"
                       :target="`btn_${data.item.id}_editar`"
            />

          </div>
        </template>

      </b-table>

      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <!-- page length -->
        <b-form-group
            label="Mostrar"
            label-cols="5"
            label-align="left"
            label-size="sm"
            label-for="sortBySelect"
            class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
              id="perPageSelect2_c"
              v-model="perPage_c"
              size="sm"
              inline
              :options="pageOptions_c"
          />

        </b-form-group>

        <!-- pagination -->
        <div>
          <b-pagination
              v-model="currentPage_c"
              :total-rows="totalRowsCategoria"
              :per-page="perPage_c"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              class="mb-0"
          >
            <template #prev-text>
              <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-card-body>

    </b-card>

    <b-modal
        id="modalRegistro"
        v-model="estadoModal"
        :title="infoModal.title"
        :ok-title="infoModal.boton"
        cancel-variant="outline-secondary"
        cancel-title="Cancelar"
        @hidden="resetModal"
        @ok="okModal"
        centered
    >
      <form
          ref="form"
          @submit.stop.prevent="enviarFormulario"
      >
        <b-row>
          <b-col md="12">
            <b-form-group
                label="Cultivo"
                label-for="idcultivo"
                invalid-feedback="Cultivo es requerido"
            >

              <v-select
                  id="idcultivo"
                  v-model="cultivoSelected"
                  :options="cultivo"
                  :reduce="cultivo => cultivo.value"
                  label="text"
                  key="value"
                  placeholder="Seleccionar..."
              >
                <span slot="no-options"> Sin datos</span>

              </v-select>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
                label="Año"
                label-for="idcultivo"
                invalid-feedback="Cultivo es requerido"
            >

              <v-select
                  id="idyear"
                  v-model="yearSelected"
                  :options="year"
                  :reduce="year => year.value"
                  label="text"
                  key="value"
                  placeholder="Seleccionar..."
              >
                <span slot="no-options"> Sin datos</span>

              </v-select>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
                :state="validacion"
                label="Semana"
                label-for="semana"
                invalid-feedback="Semana es requerida"
            >
              <b-form-input
                  id="semana"
                  placeholder="Semana"
                  v-model="semana"
                  :state="validacion"
                  @keydown="filterKey('semana',2)"
                  type="number"
                  required
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
                label="Tipo"
                label-for="idtipo"
                invalid-feedback="Tipo es requerido"
            >

              <v-select
                  id="idtipo"
                  v-model="fortipoSelected"
                  :options="fortipo"
                  :reduce="fortipo => fortipo.value"
                  label="text"
                  key="value"
                  placeholder="Seleccionar..."
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
                label="Versión"
                label-for="version"
                invalid-feedback="Versión es requerida"
            >

              <v-select
                  id="version_f"
                  v-model="versionSelected"
                  :options="version"
                  :reduce="version => version.value"
                  label="text"
                  key="value"
                  placeholder="Seleccionar..."
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
                label="Estado"
                label-for="estado"
                invalid-feedback="Estado es requerido"
            >
              <v-select
                  id="estado"
                  v-model="estado"
                  label="text"
                  :options="estados"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </form>
    </b-modal>
    <b-modal
        id="modalRegistroDetalle"
        v-model="estadoModalDetalle"
        :title="infoModal.title"
        :ok-title="infoModal.boton"
        cancel-variant="outline-secondary"
        cancel-title="Cancelar"
        @hidden="resetModalDetallle"
        @ok="okModalDetalle"
        centered
    >
      <form
          ref="form"
          @submit.stop.prevent="enviarFormularioDetalle"
      >
        <b-row>
          <b-col md="12">
            <b-form-group
                label="Sociedad"
                label-for="sociedad_f"
                invalid-feedback="sociedad es requerida"
            >
              <v-select
                  id="sociedad_f"
                  v-model="sociedadSelected"
                  :options="sociedad"
                  :reduce="sociedad => sociedad.value"
                  label="text"
                  key="value"
                  placeholder="Seleccionar..."
                  @input="llenarDetalleCultivo()"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
                label="Cultivo"
                label-for="didcultivo"
                invalid-feedback="Cultivo es requerido"
            >
              <v-select
                  id="didcultivo"
                  v-model="dcultivoSelected"
                  :options="dcultivo"
                  :reduce="dcultivo => dcultivo.value"
                  label="text"
                  key="value"
                  placeholder="Seleccionar..."
                  @input="llenarFundo()"

              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
                label="Fundo"
                label-for="idfundo"
                invalid-feedback="sociedad es requerida"
            >
              <v-select
                  id="idfundo"
                  v-model="fundoSelected"
                  :options="fundo"
                  :reduce="fundo => fundo.value"
                  label="text"
                  key="value"
                  placeholder="Seleccionar..."
                  @input="llenarEtapa()"

              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
                label="Etapa"
                label-for="etapa_f"
                invalid-feedback="Etapa es requerida"
            >

              <v-select
                  id="etapa_f"
                  v-model="etapaSelected"
                  :options="etapa"
                  :reduce="etapa => etapa.value"
                  label="text"
                  key="value"
                  placeholder="Seleccionar..."
                  @input="llenarCampo()"
              >
                <span slot="no-options"> Sin datos</span>

              </v-select>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
                label="Campo"
                label-for="campo_f"
                invalid-feedback="Campo es requerido"
            >
              <v-select
                  id="campo_f"
                  v-model="campoSelected"
                  :options="campo"
                  :reduce="campo => campo.value"
                  label="text"
                  key="value"
                  placeholder="Seleccionar..."
                  @input="llenarTurno()"
              >
                <span slot="no-options"> Sin datos</span>

              </v-select>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
                label="Turno"
                label-for="turno"
                invalid-feedback="Turno es requerido"
            >

              <v-select
                  id="turno_f"
                  v-model="turnoSelected"
                  :options="turno"
                  :reduce="turno => turno.value"
                  label="text"
                  key="value"
                  placeholder="Seleccionar..."
                  @input="llenarVariedad()"
              >
                <span slot="no-options"> Sin datos</span>

              </v-select>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
                label="Variedad"
                label-for="variedad"
                invalid-feedback="Variedad es requerida"
            >
              <v-select
                  id="variedad_f"
                  v-model="variedadSelected"
                  :options="variedad"
                  :reduce="variedad => variedad.value"
                  label="text"
                  key="value"
                  placeholder="Seleccionar..."
                  @input="llenarHasTurno()"
              >
                <span slot="no-options"> Sin datos</span>

              </v-select>
            </b-form-group>
          </b-col>
          <b-col md="6">
              <b-form-group
                  :state="validacion"
                  label="Has/Turno"
                  label-for="has_turno_f"
                  invalid-feedback="HAS Turno es requerido"
              >
                <b-form-input
                    id="has_turno_f"
                    placeholder="Hectáreas por cosechar"
                    v-model="has_turnoSelected"
                    :state="validacion"
                    required=""
                    readonly=""
                />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
                :state="validacion"
                label="Código Homologado"
                label-for="idhomologado"
                invalid-feedback="Código Homologado es requerido"
            >
              <b-form-input
                  id="idhomologado"
                  placeholder="Código Homologado"
                  v-model="codigo_homologado"
                  :state="validacion"
                  required=""
                  readonly=""
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
                :state="validacion"
                label="Has Cosecha"
                label-for="has_cosecha"
                invalid-feedback="Has cosecha es requerida"
            >
              <b-form-input
                  id="has_cosecha"
                  placeholder="Hectáreas por cosechar"
                  v-model="has_cosecha"
                  :state="validacion"
                  type="number"
                  required
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
                :state="validacion"
                label="DPC"
                label-for="dpc"
                invalid-feedback="DPC es requerida"
            >
              <b-form-input
                  id="dpc"
                  placeholder="Ingrese DPC"
                  v-model="dpc"
                  :state="validacion"
                  type="number"
                  required
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
                :state="validacion"
                label="Peso Bruto"
                label-for="peso_bruto"
                invalid-feedback="Peso bruto es requerido"
            >
              <b-form-input
                  id="peso_bruto"
                  placeholder="Ingrese peso bruto"
                  v-model="peso_bruto"
                  :state="validacion"
                  type="number"
                  required
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
                :state="validacion"
                label="Tonelada"
                label-for="tonelada"
                invalid-feedback="Tonelada es requerida"
            >
              <b-form-input
                  id="tonelada"
                  placeholder="Ingrese Tonelada"
                  v-model="tonelada"
                  :state="validacion"
                  type="number"
                  required
              />
            </b-form-group>
          </b-col>
        </b-row>
      </form>
    </b-modal>



  </div>

</template>

<script>
import axiosIns from '../../../libs/axios'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required, integer, length, max } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import flatPickr from 'vue-flatpickr-component'
import { Spanish } from "flatpickr/dist/l10n/es.js"

import {
  BCard,
  BTable,
  BAvatar,
  BBadge,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BTooltip,
  BModal,
  VBModal,
  BListGroup,
  BListGroupItem,
  BRow,
  BCol
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BTooltip,
    BModal,
    VBModal,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    vSelect,
    ToastificationContent,
    flatPickr,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      perPage: 10,
      perPage_c: 10,
      pageOptions: [10, 15, 20],
      pageOptions_c: [10, 15, 20],
      totalRows: 1,
      totalRowsCategoria:1,
      currentPage: 1,
      currentPage_c: 1,
      sortBy: 'id',
      sortBy_c: 'id_c',
      sortDesc: true,
      sortDesc_c: true,
      sortDirection: 'desc',
      sortDirection_c: 'desc',
      filter: null,
      filter_categoria :null,
      filterOn: [],
      filterOnCategoria: [],
      estadoModal: false,
      estadoModalDetalle:false,
      codigo_forescast:"",
      infoModal: {
        title: '',
        boton: '',
      },
      fields: [
        {
          key: 'acciones',
          label: 'acciones',
          sortable: true
        },
        {
          key: 'nombre_cultivo',
          label: 'CULTIVO',
          sortable: true
        },
        {
          key: 'numero_year',
          label: 'Año',
          sortable: true
        },
        {
          key: 'semana_proyectada',
          label: 'Semana',
          sortable: true
        },
        {
          key: 'nombre_tipo',
          label: 'TIPO',
          sortable: true
        },
        {
          key: 'nombre_version',
          label: 'Versión',
          sortable: true
        },
        {
          key: 'estado',
          label: 'estado',
          sortable: true
        },
        {
          key: 'estado',
          label: 'Estado',
        },
        {
          key: 'fecha_registro',
          label: 'FECHA REGISTRO',
          sortable: true
        },
        {
          key: 'usuario',
          label: 'usuario',
          sortable: true
        },
      ],
      fieldsCategorias: [
        {
          key: 'acciones_detalle',
          label: 'acciones',
          sortable: true
        },
        {
          key: 'sociedad',
          label: 'sociedad',
          sortable: true
        },
        {
          key: 'cultivo',
          label: 'cultivo',
          sortable: true
        },
        {
          key: 'fundo',
          label: 'fundo',
          sortable: true
        },
        {
          key: 'etapa',
          label: 'etapa',
          sortable: true
        },
        {
          key: 'campo',
          label: 'campo',
          sortable: true
        },
        {
          key: 'turno',
          label: 'turno',
          sortable: true
        },
        {
          key: 'variedad',
          label: 'variedad',
          sortable: true
        },
        {
          key: 'has_turno',
          label: 'has_turno',
        },
        {
          key: 'codigo_homologado_sysagro',
          label: 'Código Homologado',
        },
        {
          key: 'ha_por_cosechar',
          label: 'Has cosecha',
          sortable: true
        },
        {
          key: 'dpc',
          label: 'dpc',
          sortable: true
        },
        {
          key: 'peso_bruto',
          label: 'Peso bruto',
          sortable: true
        },
        {
          key: 'tonelada',
          label: 'tonelada',
          sortable: true
        },
        {
          key: 'detalle_estado',
          label: 'Estado',
        },
      ],
      items: [],
      itemsCategorias: [],
      status: [
        {
          '1': 'Activo',
          '0': 'Inactivo',
        },
        {
          '1': 'light-success',
          '0': 'light-danger',
        }
      ],
      validacion: null,
      estados: [
        {value: 1, text: "Activo"},
        {value: 0, text: "Inactivo"}
      ],
      codigo: '',
      descrip: '',
      nombre: '',
      estado: {value: 0, text: "Activo"},
      id: 0,
      tipo: 0,
      for_tipo: [],
      for_tipoSelected: null,
      semana:"",
      version: [],
      versionSelected:null,
      sociedad: [],
      sociedadSelected:null,
      etapa: [],
      etapaSelected:null,
      campo: [],
      campoSelected:null,
      turno: [],
      turnoSelected:null,
      variedad: [],
      variedadSelected:null,
      has_turno: [],
      has_turnoSelected:null,
      has_cosecha: "",
      dpc: "",
      peso_bruto: "",
      tonelada:"",
      spd: [],
      fechaForecast: null,
      maxLength212: 10,
      required,
      integer,
      length,
      maxlength,
      max,

      fotos: [],
      fotosFirma: "",
      fortipo: [],
      fortipoSelected: null,
      semana:"",
      version: [],
      versionSelected:null,
      cultivo: [],
      cultivoSelected:null,
      year: [],
      yearSelected:null,
      sociedad: [],
      sociedadSelected:null,
      dcultivo: [],
      dcultivoSelected:null,
      fundo: [],
      fundoSelected:null,
      etapa: [],
      etapaSelected:null,
      campo: [],
      campoSelected:null,
      turno: [],
      turnoSelected:null,
      variedad: [],
      variedadSelected:null,
      has_turno: [],
      has_turnoSelected:null,
      codigo_homologado:"",
      has_cosecha: "",
      dpc: "",
      peso_bruto: "",
      tonelada:"",
      spd: [],
      fechaForecast: null,
      maxLength212: 10,
      required,
      integer,
      length,
      maxlength,
      max,
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
          .filter(f => f.sortable)
          .map(f => ({
            text: f.label,
            value: f.key
          }))
    },
  },
  mounted() {
    this.traerForecasting();
    this.llenarCultivo();
    this.llenarYear();
    this.llenarTipos();
    this.llenarVersiones();
    this.llenarSociedad();

  },
  methods: {
    traerForecasting(){
      var yo = this

      var config = {
        method: 'get',
        url: '/forecast/forecast/list/'
      };

      axiosIns(config)
          .then(function (response) {
            console.log(response);
            yo.items = response.data.response;
            console.log(yo.items);

            yo.totalRows = yo.items.length
          })
          .catch(function (error) {
            console.log(error);
          });
    },

    registrarDetalle(){

    },


    llenarCultivo(){
      var yo = this

      yo.for_tipo = [];
      var config = {
        method: 'get',
        url: '/forecast/forecast/cultivos/'
      };
      axiosIns(config)
          .then(function (response) {
            var cultivos = response.data;
            var totalRows = cultivos.length

            for (var i = 0 ; i <  totalRows; i++){
              yo.cultivo.push({value: cultivos[i].id.toString(), text: cultivos[i].nombre.toString()});
            }

          })
          .catch(function (error) {
            console.log(error);
          });
    },
    llenarYear(){
      var yo = this

      yo.for_tipo = [];
      var config = {
        method: 'get',
        url: '/forecast/forecast/years/'
      };
      axiosIns(config)
          .then(function (response) {
            var years = response.data;
            var totalRows = years.length

            for (var i = 0 ; i <  totalRows; i++){
              yo.year.push({value: years[i].id.toString(), text: years[i].numero_year.toString()});
            }

          })
          .catch(function (error) {
            console.log(error);
          });
    },
    llenarTipos(){
      var yo = this

      yo.for_tipo = [];
      var config = {
        method: 'get',
        url: '/forecast/forecast/tipos/'
      };
      axiosIns(config)
          .then(function (response) {
            var tipos = response.data;
            var totalRows = tipos.length

            for (var i = 0 ; i <  totalRows; i++){
              yo.fortipo.push({value: tipos[i].id.toString(), text: tipos[i].nombre.toString()});
            }

          })
          .catch(function (error) {
            console.log(error);
          });
    },
    llenarVersiones(){
      var yo = this

      yo.version = [];
      var config = {
        method: 'get',
        url: '/forecast/forecast/versiones/'
      };
      axiosIns(config)
          .then(function (response) {
           var version = response.data;
            var totalRows = version.length
            for (var i = 0 ; i <  totalRows; i++){
              yo.version.push({value: version[i].id.toString(), text: version[i].nombre.toString()});
            }

          })
          .catch(function (error) {
            console.log(error);
          });
    },
    llenarSociedad(){
      var yo = this

      yo.sociedad = [];
      var config = {
        method: 'get',
        url: '/forecast/forecast/traerSociedad/'
      };
      axiosIns(config)
          .then(function (response) {
            var response = response.data.response;
            var totalRows = response.length
            for (var i = 0 ; i < totalRows; i++){
              var codigoHomologado = response[i].cod_homologado.toString();
              var nomnbreCodigoHomologado = response[i].sociedad.toString();
              var nomnbreCodigoHomologado_value = response[i].sociedad.toString();
              if(codigoHomologado=="AGV"){
                nomnbreCodigoHomologado = "AGROVISIÓN";
              }
              yo.sociedad.push({value: nomnbreCodigoHomologado_value, text: nomnbreCodigoHomologado});
            }


          })
          .catch(function (error) {
            console.log(error);
          });
    },
    llenarDetalleCultivo(){
      var yo = this

      var sociedad = yo.sociedadSelected;

      var body =  "" +
          "codigo_sociedad=" +sociedad+
          "";

      var config = {
        method: 'get',
        url: '/forecast/forecast/traerCultivoSysAgro/?'+body,
        headers: { },
      };
      yo.dcultivo = [];

      axiosIns(config)
          .then(function (response) {
            var cultivos = response.data.response;
            var totalRows = cultivos.length;

            for (var i = 0 ; i <  totalRows; i++){
              yo.dcultivo.push({value: cultivos[i].cultivo.toString(), text: cultivos[i].cultivo.toString()});
            }
           // yo.dcultivoSelected = yo.dcultivo[0].value;

          })
          .catch(function (error) {
            console.log(error);
          });
    },
    llenarFundo(){
      var yo = this

      var sociedad = yo.sociedadSelected;
      var cultivo = yo.dcultivoSelected;
      yo.fundo = [];
      var body =  "" +
          "codigo_sociedad=" +sociedad+'&'+
          "codigo_cultivo=" +cultivo+
          "";

      var config = {
        method: 'get',
        url: '/forecast/forecast/traerFundo/?'+body,
        headers: { },
      };

      axiosIns(config)
          .then(function (response) {
            var response = response.data.response;
            var totalRows = response.length
            for (var i = 0 ; i <  totalRows; i++){
              yo.fundo.push({value: response[i].fundo.toString(), text:response[i].fundo.toString()});
            }
            //yo.fundoSelected = yo.fundo[0].value;
          })
          .catch(function (error) {
            console.log(error);
          });
    },
    llenarEtapa(){
      var yo = this

      var sociedad = yo.sociedadSelected;
      var cultivo = yo.dcultivoSelected;
      var fundo = yo.fundoSelected;

      yo.etapa = [];
      var body =  "" +
                "codigo_sociedad=" +sociedad+'&'+
                "codigo_cultivo=" +cultivo+'&'+
                "codigo_fundo=" +fundo+
                  "";

      var config = {
        method: 'get',
        url: '/forecast/forecast/traerEtapa/?'+body,
        headers: { },
      };

      axiosIns(config)
          .then(function (response) {
            var response = response.data.response;
            var totalRows = response.length
            for (var i = 0 ; i <  totalRows; i++){
              yo.etapa.push({value: response[i].etapa.toString(), text:response[i].etapa.toString()});
            }
            //yo.etapaSelected = yo.etapa[0].value;
            //yo.llenarCampo();

          })
          .catch(function (error) {
            console.log(error);
          });
    },
    llenarCampo(){
      var yo = this

      var sociedad = yo.sociedadSelected;
      var cultivo = yo.dcultivoSelected;
      var fundo = yo.fundoSelected;
      var etapa = yo.etapaSelected;
      yo.campo = [];
      var body =  "" +
          "codigo_sociedad=" +sociedad+'&'+
          "codigo_cultivo=" +cultivo+'&'+
          "codigo_fundo=" +fundo+'&'+
          "codigo_etapa=" +etapa+
          "";

      var config = {
        method: 'get',
        url: '/forecast/forecast/traerCampo/?'+body,
        headers: { },
      };

      axiosIns(config)
          .then(function (response) {
            var response = response.data.response;
            var totalRows = response.length
            for (var i = 0 ; i <  totalRows; i++){
              yo.campo.push({value: response[i].campo.toString(), text:response[i].campo.toString()});
            }
           // yo.campoSelected = yo.campo[0].value;

            //yo.llenarTurno();
          })
          .catch(function (error) {
            console.log(error);
          });
    },
    llenarTurno(){
      var yo = this

      var sociedad = yo.sociedadSelected;
      var cultivo = yo.dcultivoSelected;
      var fundo = yo.fundoSelected;
      var etapa = yo.etapaSelected;
      var campo = yo.campoSelected;
      yo.turno = [];
      var body =  "" +
          "codigo_sociedad=" +sociedad+'&'+
          "codigo_cultivo=" +cultivo+'&'+
          "codigo_fundo=" +fundo+'&'+
          "codigo_etapa=" +etapa+'&'+
          "codigo_campo=" +campo+
          "";

      var config = {
        method: 'get',
        url: '/forecast/forecast/traerTurno/?'+body,
        headers: { },
      };

      axiosIns(config)
          .then(function (response) {
            var response = response.data.response;
            var totalRows = response.length
            for (var i = 0 ; i <  totalRows; i++){
              yo.turno.push({value: response[i].turno.toString(), text:response[i].turno.toString()});
            }

            //yo.turnoSelected = yo.turno[0].value;

           // yo.llenarVariedad();


          })
          .catch(function (error) {
            console.log(error);
          });
    },
    llenarVariedad(){
      var yo = this

      var sociedad = yo.sociedadSelected;
      var cultivo = yo.dcultivoSelected;
      var fundo = yo.fundoSelected;
      var etapa = yo.etapaSelected;
      var campo = yo.campoSelected;
      var turno = yo.turnoSelected;
      yo.variedad = [];
      var body =  "" +
          "codigo_sociedad=" +sociedad+'&'+
          "codigo_cultivo=" +cultivo+'&'+
          "codigo_fundo=" +fundo+'&'+
          "codigo_etapa=" +etapa+'&'+
          "codigo_campo=" +campo+'&'+
          "codigo_turno=" +turno+
          "";

      var config = {
        method: 'get',
        url: '/forecast/forecast/traerVariedad/?'+body,
        headers: { },
      };

      axiosIns(config)
          .then(function (response) {
            var response = response.data.response;
            var totalRows = response.length
            for (var i = 0 ; i <  totalRows; i++){
              yo.variedad.push({value: response[i].variedad.toString(), text:response[i].variedad.toString()});
            }

           // yo.variedadSelected = yo.variedad[0].value;
            //yo.llenarHasTurno();

          })
          .catch(function (error) {
            console.log(error);
          });
    },
    llenarHasTurno(){
      var yo = this

      var sociedad = yo.sociedadSelected;
      var cultivo = yo.dcultivoSelected;
      var fundo = yo.fundoSelected;
      var etapa = yo.etapaSelected;
      var campo = yo.campoSelected;
      var turno = yo.turnoSelected;
      var variedad = yo.variedadSelected;
      var variedad_limpia = variedad.replace(/[^\w\s]/gi, '\n');
      yo.has_turno = [];
      var body =  "" +
          "codigo_sociedad=" +sociedad+'&'+
          "codigo_cultivo=" +cultivo+'&'+
          "codigo_fundo=" +fundo+'&'+
          "codigo_etapa=" +etapa+'&'+
          "codigo_campo=" +campo+'&'+
          "codigo_turno=" +turno+'&'+
          "codigo_variedad=" +variedad_limpia+
          "";

      var config = {
        method: 'get',
        url: '/forecast/forecast/traerHasTurno/?'+body,
        headers: { },
      };

      axiosIns(config)
          .then(function (response) {
            var response = response.data.response;
            var totalRows = response.length
            console.log(response);
            yo.has_turnoSelected = response[0].area.toString();
            yo.codigo_homologado = response[0].cod_homologado.toString();

            //for (var i = 0 ; i <  totalRows; i++){
              //console.log(response[i].area.toString());
             // yo.has_turno.push({value: response[i].cod_homologado.toString()+'/-/'+response[i].area.toString(), text:response[i].area.toString()});
            //}
            //yo.has_turnoSelected = yo.has_turno[0].value;

          })
          .catch(function (error) {
            console.log(error);
          });
    },

    cPaginacion(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    cPaginacion_c(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRowsCategoria = filteredItems.length
      this.currentPage_c = 1
    },

    mostrarModal(tipo, id, nombre, estado){
      this.tipo = tipo
      this.estadoModal = true

      if (this.tipo === 1 ){
        this.infoModal.title = 'Registrar Forecast'
        this.infoModal.boton = 'Registrar'
      }
      else if (this.tipo === 2 ){
        this.infoModal.title = 'Editar Forecast'
        this.infoModal.boton = 'Editar'

        this.id = id
        this.nombre = nombre

        this.estado = {value: parseInt(estado), text: estado === '1' ? 'Activo' : 'Inactivo'}
      }
    },

    mostrarNotificacion(titulo, icono, texto, variante){
      this.$toast({
            component: ToastificationContent,
            props:{
              title: titulo,
              icon: icono,
              text: texto,
              variant: variante
            }
          },
          {
            timeout: 5000
          })
    },

    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.boton = ''
      this.estadoModal = false
    },

    validarFormulario() {
      const valid = this.$refs.form.checkValidity()
      this.validacion = valid
      return valid
    },

    resetModal() {
      this.codigo = ''
      this.descrip = ''
      this.nombre = ''
      this.estado = {value: 1, text: "Activo"}
      this.validacion = null
      this.resetInfoModal()
    },

    okModal(bvModalEvt) {

      bvModalEvt.preventDefault()

      this.enviarFormulario()
    },

    enviarFormulario() {
      // Hide the modal manually
      this.$nextTick(() => {
        var yo = this


        let date_Actual = new Date();
        let date = yo.addHoursToDate(date_Actual,-5);
        let fecha_actual = date.getFullYear() +'-' + String(date.getMonth() + 1).padStart(2, '0')+'-'+ String(date.getDate()).padStart(2, '0');
        let hora_actual = String(date.getHours()).padStart(2, '0')+':'+ String(date.getMinutes()).padStart(2, '0')+':'+String(date.getSeconds()).padStart(2, '0');

        //var arrayFechaForecast = yo.fechaForecast.toString().split('/');
        //var fechaForecastFormateado = arrayFechaForecast[2]+'-'+arrayFechaForecast[1]+'-'+arrayFechaForecast[0];
        //var codigoFechaForecast = arrayFechaForecast[2]+''+arrayFechaForecast[1]+''+arrayFechaForecast[0];

        var codigofechaforecast = "00000000";
        //alert(yo.yearSelected.);
       // var primerdiasemana = new Date(year, 0, (yo.semana - 1) * 7 + 1);

        var data = JSON.stringify({
          "for_cultivo": yo.cultivoSelected,
          "for_forecast_year": yo.yearSelected,
          "semana_proyectada": yo.semana,
          "codigo_fecha_forecast":codigofechaforecast,
          "for_tipo": yo.fortipoSelected,
          "for_version": yo.versionSelected,
          "fecha_registro":fecha_actual,
          "usuario": 'LTERRONES',
          "estado": '1',
        });

        var url = this.tipo === 1 ? '/forecast/orecast/crear/' : '/forecast/forecast/editar/'+this.id
        var metodo = this.tipo === 1 ? 'post' : 'patch'

        var config = {
          method: metodo,
          url: url,
          headers: {
            'Content-Type': 'application/json'
          },
          data : data
        };

        axiosIns(config)
            .then(function (response) {

              if (response.status === 201 || response.status === 200){
                yo.traerForecasting();

                if (yo.tipo === 1){
                  yo.mostrarNotificacion('Registro creado', 'CheckIcon', 'El Forecast' + '' + ' ha sido registrado correctamente', 'success')
                }else{
                  yo.mostrarNotificacion('Registro modificado', 'CheckIcon', 'El Forecast' + '' + ' ha sido modificado correctamente', 'success')
                }

              }else{
                yo.mostrarNotificacion('Error', 'BellIcon', JSON.stringify(response.data).toString(), 'danger')
              }

            })
            .catch(function (error) {
              console.log(error);
              yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger')
            });

        this.estadoModal = false
      })
    },

    resetModalDetallle() {
      this.infoModal.title = ''
      this.infoModal.boton = ''
      this.estadoModal = false
    },
    okModalDetalle(bvModalEvt) {

      bvModalEvt.preventDefault()

      this.enviarFormularioDetalle()
    },
    mostrarModalDetalle(tipo, id, nombre, estado){
      this.tipo = tipo
      this.estadoModalDetalle = true;
      this.limpiarCamposDetalle();

      if (this.tipo === 1 ){
        this.infoModal.title = 'Registrar Detalle Forecast'
        this.infoModal.boton = 'Registrar'
      }
      else if (this.tipo === 2 ){
        this.infoModal.title = 'Editar Detalle Forecast'
        this.infoModal.boton = 'Editar'

        this.id = id
        this.nombre = nombre

      }
    },
    enviarFormularioDetalle() {

      this.$nextTick(() => {
        var yo = this

        let date_Actual = new Date();
        let date = yo.addHoursToDate(date_Actual,-5);
        let fecha_actual = date.getFullYear() +'-' + String(date.getMonth() + 1).padStart(2, '0')+'-'+ String(date.getDate()).padStart(2, '0');
        let hora_actual = String(date.getHours()).padStart(2, '0')+':'+ String(date.getMinutes()).padStart(2, '0')+':'+String(date.getSeconds()).padStart(2, '0');


        var data = JSON.stringify({
          "sociedad": yo.sociedadSelected,
          "cultivo": yo.dcultivoSelected,
          "fundo": yo.fundoSelected,
          "etapa":yo.etapaSelected,
          "campo": yo.campoSelected,
          "turno": yo.turnoSelected,
          "variedad":yo.variedadSelected,
          "has_turno": yo.has_turnoSelected,
          "codigo_homologado_sysagro": yo.codigo_homologado,
          "ha_por_cosechar": yo.has_cosecha,
          "dpc": yo.dpc,
          "peso_bruto": yo.peso_bruto,
          "tonelada": yo.tonelada,
          "for_forecast": yo.codigo_forescast,
          "detalle_estado": '1',
        });


        var url = this.tipo === 1 ? '/forecast/forecast/detalle/crear/' : '/forecast/forecast/detalle/editar/'+this.id
        var metodo = this.tipo === 1 ? 'post' : 'patch'

        var config = {
          method: metodo,
          url: url,
          headers: {
            'Content-Type': 'application/json'
          },
          data : data
        };

        axiosIns(config)
            .then(function (response) {

              if (response.status === 201 || response.status === 200){
                yo.listarDetalleForecast(yo.codigo_forescast);

                if (yo.tipo === 1){
                  yo.estadoModalDetalle = false;
                  yo.mostrarNotificacion('Registro creado', 'CheckIcon', 'El Forecast' + '' + ' ha sido registrado correctamente', 'success')
                }else{
                  yo.estadoModalDetalle = false;
                  yo.mostrarNotificacion('Registro modificado', 'CheckIcon', 'El Forecast' + '' + ' ha sido modificado correctamente', 'success')
                }

              }else{
                yo.mostrarNotificacion('Error', 'BellIcon', JSON.stringify(response.data).toString(), 'danger')
              }

            })
            .catch(function (error) {
              console.log(error);
              yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger')
            });

        this.estadoModal = false
      })
    },

    limpiarCamposDetalle(){

      var yo = this;

      yo.sociedadSelected = "";
      yo.fundoSelected = "";
      yo.etapaSelected = "";
      yo.campoSelected = "";
      yo.turnoSelected = "";
      yo.variedadSelected = "";
      yo.has_turnoSelected = "";
      yo.codigo_homologado = "";
      yo.has_cosecha = "";
      yo.dpc = "";
      yo.peso_bruto = "";
      yo.tonelada = "";
    },
    anularRegistro(id,estado){
      var yo = this
      var icon = "warning"
      var mensaje = " dar de baja";
      var valorUpdate = "0";
      var mensajeSalida = "Registro dado de baja";

      if(estado =="0"){
        icon ='success';
        mensaje = "activar";
        valorUpdate = "1";
        mensajeSalida = "Registro activado";

      }
      this.$swal({
        title: '¡Alerta!',
        text: "¿Seguro que quieres "+mensaje+" el Forecast ?",
        icon: icon,
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-danger',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {

          this.$nextTick(() => {

            var yo = this

            var data = JSON.stringify({
              "estado": valorUpdate
            });

            var url = '/forecast/forecast/editar/'+id
            var metodo = 'patch'

            var config = {
              method: metodo,
              url: url,
              headers: {
                'Content-Type': 'application/json'
              },
              data : data
            };

            axiosIns(config)
                .then(function (response) {

                  if (response.status === 201 || response.status === 200){
                    yo.traerForecasting();

                    yo.mostrarNotificacion(mensajeSalida, 'CheckIcon', 'El Forecast  ha sido modificado correctamente', 'success')


                  }else{
                    yo.mostrarNotificacion('Error', 'BellIcon', JSON.stringify(response.data).toString(), 'danger')
                  }

                })
                .catch(function (error) {
                  console.log(error);
                  yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger')
                });

            this.estadoModal = false
          })

        }
      })
    },
    anularRegistroDetalle(id,estado){

      var icon = "warning"
      var mensaje = " dar de baja";
      var valorUpdate = "0";
      var mensajeSalida = "Registro dado de baja";

      if(estado =="0"){
        icon ='success';
        mensaje = "activar";
        valorUpdate = "1";
        mensajeSalida = "Registro activado";

      }

      this.$swal({
        title: '¡Alerta!',
        text: "¿Seguro que quieres "+mensaje+" el detalle de este Forecast ?",
        icon: icon,
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-danger',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {

          this.$nextTick(() => {

            var yo = this

            var data = JSON.stringify({
              "detalle_estado": valorUpdate
            });

            var url = '/forecast/forecast/detalle/editar/'+id
            var metodo = 'patch'

            var config = {
              method: metodo,
              url: url,
              headers: {
                'Content-Type': 'application/json'
              },
              data : data
            };

            axiosIns(config)
                .then(function (response) {

                  if (response.status === 201 || response.status === 200){
                    yo.listarDetalleForecast(yo.codigo_forescast);

                    yo.mostrarNotificacion(mensajeSalida, 'CheckIcon', 'El Detalle del Forecast  ha sido modificado correctamente', 'success')


                  }else{
                    yo.mostrarNotificacion('Error', 'BellIcon', JSON.stringify(response.data).toString(), 'danger')
                  }

                })
                .catch(function (error) {
                  console.log(error);
                  yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger')
                });

            this.estadoModal = false
          })

        }
      })
    },

    verCagetorias(id,cultivo){

      this.codigo_forescast = "";
      this.codigo_forescast = id;
      const cardListEvaluacion = document.querySelector('#listEvaluaciones');
      const cardListCategoria = document.querySelector('#listCategorias');


      if (cardListCategoria.style.display === "none") {
        cardListEvaluacion.style.display = "none";
        cardListCategoria.style.display = "block";
      }


      //yo.totalRowsCategoria = yo.itemsCategorias.length;

      var yo = this
      yo.listarDetalleForecast(id);



    },
    listarDetalleForecast(id){

       var yo = this
      yo.itemsCategorias="";


      var config = {
        method: 'get',
        url: '/forecast/forecast/detalle/byid/?codigo_forecast='+id
      };

      axiosIns(config)
          .then(function (response) {
            yo.itemsCategorias = response.data.response;
            yo.totalRows = yo.itemsCategorias.length
            console.log(yo.itemsCategorias);
          })
          .catch(function (error) {
            console.log(error);
          });

    },

    regresarInicio(){
      const cardListEvaluacion = document.querySelector('#listEvaluaciones');
      const cardListCategoria = document.querySelector('#listCategorias');


      if (cardListCategoria.style.display === "block") {
        cardListEvaluacion.style.display = "block";
        cardListCategoria.style.display = "none";
      }
    },

    filterKey(modelo,max_length){
        var yo = this;


    },
    addHoursToDate(objDate, intHours) {
      var numberOfMlSeconds = objDate.getTime();
      var addMlSeconds = (intHours * 60) * 60000;
      var newDateObj = new Date(numberOfMlSeconds + addMlSeconds);

      return newDateObj;
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
